import React from 'react';
import {observer} from 'mobx-react';

import {useWebScreenDimensions} from '../../../hooks/useWebScreenDimensions';
import {useStores} from '../../../stores/use-stores';
import {EmptyCart} from '../CartScreen';

import CartLineItem from './CartLineItem';
import GiftCardStoreCartLineItem from './GiftCardStoreCartLineItem';

type OrderItemsProps = {
  isGiftCardStore?: boolean;
};

export const OrderItems = observer(
  ({isGiftCardStore = false}: OrderItemsProps) => {
    const {cartStore} = useStores();
    const {isWebDesktopScreen} = useWebScreenDimensions();

    const renderCartLineItem = (item: any, index: any) =>
      isGiftCardStore ? (
        <GiftCardStoreCartLineItem
          item={item}
          index={index}
          key={item.product_id}
          isGiftCardStore={isGiftCardStore}
        />
      ) : (
        <CartLineItem
          item={item}
          index={index}
          key={item.product_id}
          isGiftCardStore={isGiftCardStore}
        />
      );

    const data = cartStore.currentOrder?.order_lines?.filter(
      (line: any) => !line.charge,
    );

    return data && data.length ? (
      data.map(renderCartLineItem)
    ) : (
      <EmptyCart isWebDesktopScreen={isWebDesktopScreen} />
    );
  },
);
